import React, { useState } from "react";
import styles from "./TableRow.module.scss";
import axios from "axios";
import { API_URL } from "../../../../http/index";
import { useTranslation } from "react-i18next";
import tokenNew from "../../../../img/tokenNew.webp";
import cn from "classnames";

const TableRow = ({
  plants_purchase_date,
  representational_id,
  id,
  total_amount,
  plants_count,
  isView = false,
  amountPayout,
}) => {
  // const [checked, setChecked] = useState(plants_auto_sale)
  const [periodicity, setPeriodicityWithdraws] = useState(4);
  const { t } = useTranslation();

  function downloadPDF(pdf, id) {
    const fileURL = URL.createObjectURL(pdf);
    let alink = document.createElement("a");
    alink.href = fileURL;
    alink.download = `Rechnungs-${id}.pdf`;
    alink.click();
  }

  const download = () => {
    axios({
      method: "get",
      url: `${API_URL}/v1/finances/pdf/${id}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
        Accept: "application/pdf",
      },
      responseType: "blob",
    })
      .then((res) => {
        downloadPDF(res.data, id);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const checkSorte = (date) => {
    const month = new Date(date).getMonth();
    const year =new Date(date).getFullYear();
    return (month <= 4 &&year==2024) ||year<2024 ? 'NFT Sorte 1' : month >= 5 && month <= 6 &&year==2024 ? 'NFT Sorte 2' : 'NFT Sorte 3';
  };

  const forbiddenOrderIds = [284, 295];

  return (
    <div className={`${styles.row} ${isView ? styles.view : ""}`} key={id}>
      <div className={styles.row__icon}>
        <img src={tokenNew} alt="token" />

        {forbiddenOrderIds.includes(id) ? (
          <></>
        ) : (
          <div className={styles.row__download} onClick={() => download()}>
            {t("Download invoice")}
          </div>
        )}
      </div>
      <div className={styles.row__id}>{representational_id}</div>
      <div className={styles.row__table}>
        {/* <div className={styles.row__row}>
          <div className={styles.row__row_label}>{t("Purchase date")}:</div>
          <div className={styles.row__row_value}>
            {moment(plants_purchase_date).format("DD.MM.YYYY")}{" "}
            {localStorage.getItem("i18n") == "EN"
              ? moment(plants_purchase_date).format("hh:mm a")
              : moment(plants_purchase_date).format("HH:mm [Uhr]")}
          </div>
        </div> */}
        <div className={styles.row__row}>
          <div className={styles.row__row_label}>{t("Quantity:")}</div>
          <div className={styles.row__row_value}>
            {Number(plants_count)
              .toFixed(2)
              .toLocaleString("de-DE", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
              .toString()
              .replace(".", ",")}{" "}
            DECT
          </div>
        </div>
        <div className={styles.row__row}>
          <div className={styles.row__row_label}>{t("Value:")}</div>
          <div className={styles.row__row_value}>
            {" "}
            {parseFloat(total_amount).toLocaleString("de-DE", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}{" "}
            €
          </div>
        </div>
        <div className={styles.row__row}>
          <div className={styles.row__row_label}>{t("NFT")}:</div>
          <div className={styles.row__row_value}>
            {/* {Math.floor(plants_count) * amountPayout} € {t("payout")} */}
            {amountPayout ? amountPayout : checkSorte(plants_purchase_date)}
          </div>
        </div>
        <div className={styles.row__row}>
          <div className={styles.row__row_label}>{t("Status")}:</div>
          <div className={styles.row__row_value}>{t("Under construction")}</div>
        </div>
        <div className={styles.row__row}>
          <div className={styles.row__row_label}>{t("Genetics")}:</div>
          <div className={styles.row__row_value}>{t("Sativa")}</div>
        </div>
        <div className={styles.row__row}>
          <div className={styles.row__row_label}>{t("Harvest")}:</div>
          <div className={styles.row__row_value}>{t("Info follows")}</div>
        </div>
        <div className={cn(styles.row__row, styles.row__row_direction)}>
          <div className={styles.row__row_label}>{t("Payout")}:</div>
          <div className={styles.row__row_value}>{t("After the harvest")}</div>
        </div>
      </div>
    </div>
  );
};

export default TableRow;
